import { MDCRipple } from '@material/ripple'

export default {
  setup() {
    this.iconButtonRipple = new MDCRipple(this.el)
    this.iconButtonRipple.unbounded = true
  },
  destroy() {
    this.iconButtonRipple?.destroy()
    this.iconButtonRipple = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
